import axios from 'axios'

class DocumentoApiClient {
    async buscarTiposDocumento() {
        return axios.get('api/tiposdocumentos/ativos')
    }
    async buscarDocumentos(params) {
        return axios.get(`api/documentos/buscar?${params}`)
    }
    async enviarDocumento(formData) {
        return axios.post('api/documento/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }
    async deletarDocumento(id) {
        return axios.delete(`api/documentos/${id}`)
    }
    async baixarDocumento(id) {
        return axios.get(`api/documento/${id}/baixar`, {
            responseType: 'arraybuffer',
        })
    }
    async downloadAnexo(anexo) {
        return axios.get('api/v1/arquivos', {
            params: { uri: anexo },
            responseType: 'arraybuffer',
        })
    }
    async assinarDocumentoEletronicamente(idExterno) {
        return axios.post(`api/documentos/${idExterno}/assinar-eletronicamente`)
    }

    async buscarSignatariosDocumento(idExterno) {
        return axios.get(`api/documentos/${idExterno}/signatarios`)
    }
    async convidarSignatariosDocumento(idExterno, signatarios) {
        return axios.post(`api/documento/${idExterno}/signatarios`, {
            emailsSignatarios: signatarios,
        })
    }
    async removerSignatarioDocumento(idExterno, emailSignatario) {
        return axios.delete(
            `api/documento/${idExterno}/signatarios?emailSignatario=${emailSignatario}`
        )
    }

    async iniciarAssinaturaDigitalDocumento(idDocumento, certificado) {
        return axios.post(
            `api/documentos/${idDocumento}/assinar-digitalmente/iniciar`,
            { certificado }
        )
    }

    async buscarLicencaLacunaFlowbeeDocumento() {
        return axios.get('api/configuracao/licenca-lacuna')
    }

    async finalizarAssinaturaDigitalDocumento(
        idDocumento,
        assinatura,
        assinaturaTemporariaId,
        rubricaBase64,
        participacao
    ) {
        const requestData = {
            assinatura,
            assinaturaTemporariaId,
            rubricaBase64,
            participacao,
        }

        return axios.post(
            `api/documentos/${idDocumento}/assinar-digitalmente/finalizar`,
            requestData
        )
    }
}

export default new DocumentoApiClient()
